export default __webpack_public_path__ + "static/media/collections_9.f6543019.webp";